import { createAsyncThunk } from "@reduxjs/toolkit";
import externalAxios  from '../../services/external-utility';
import externalUtilityv1 from "../../services/external-utilityv1";


// const fetchArchiveServicesSchoolData = createAsyncThunk(
//   "archive-services/fetchArchiveServicesSchoolData",
//   async ({year_id,region_type,region_code,category_code,management_code,location_code,school_type_code}) => {
//     const response = await externalAxios.post(`${year_id}/${region_type}/${region_code}/${category_code}/${management_code}/${location_code}/${school_type_code}`);
    
//     return response.data;
//   }
// );
const fetchArchiveServicesSchoolData = createAsyncThunk(
  "archive-services/fetchArchiveServicesSchoolData",
  async (filterObj) => {
    const response = await externalAxios.post(`schools-basic-infra/public`,filterObj);
    ////console.log('response00', response)
    return response.data;
  }
);

const fetchArchiveServicesProfileSchoolData = createAsyncThunk(
  "archive-services/fetchArchiveServicesProfileSchoolData",
  async (filterObj) => {
    const response = await externalAxios.post(`profile-details/public`,filterObj);
    //console.log('response00', response)
    return response.data;
  }
);

const fetchArchiveServicesStudentData = createAsyncThunk(
  "archive-services/fetchArchiveServicesStudentData",
  async (filterObj) => {
    ////console.log('filterObj', filterObj)
    const response = await externalAxios.post(`students-enrollment/public`,filterObj);
    ////console.log('fetchArchiveServicesStudentData', response)
    return response.data;
  }
);

const fetchArchiveServicesCWSNEnrolmentData = createAsyncThunk(
  "archive-services/fetchArchiveServicesCWSNEnrolmentData",
  async (filterObj) => {
    ////console.log('filterObj', filterObj)
    const response = await externalAxios.post(`cwsn-enrolment/public`,filterObj);
    ////console.log('fetchArchiveServicesCWSNEnrolmentData', response)
    return response.data;
  }
);

const fetchArchiveServicesTeacherData = createAsyncThunk(
  "archive-services/fetchArchiveServicesTeacherData",
  async (filterObj) => {
    ////console.log('filterObj', filterObj)
    const response = await externalAxios.post(`teachers/public`,filterObj);
    ////console.log('fetchArchiveServicesTeacherData', response)
    return response.data;
  }
);

const fetchArchiveServicesClassesTaughtData = createAsyncThunk(
  "archive-services/fetchArchiveServicesClassesTaughtData",
  async (filterObj) => {
    ////console.log('filterObj', filterObj)
    const response = await externalAxios.post(`classes-taught/public`,filterObj);
    ////console.log('fetchArchiveServicesTeacherData', response)
    return response.data;
  }
);

const fetchArchiveServicesTeacherDisabilityData = createAsyncThunk(
  "archive-services/fetchArchiveServicesTeacherDisabilityData",
  async (filterObj) => {
    ////console.log('filterObj', filterObj)
    const response = await externalAxios.post(`teachers-disability/public`,filterObj);
    ////console.log('fetchArchiveServicesTeacherDisabilityData', response)
    return response.data;
  }
);

const fetchArchiveServicesTeacherTrainingData = createAsyncThunk(
  "archive-services/fetchArchiveServicesTeacherTrainingData",
  async (filterObj) => {
    ////console.log('filterObj', filterObj)
    const response = await externalAxios.post(`teachers-training/public`,filterObj);
    ////console.log('fetchArchiveServicesTeacherTrainingData', response)
    return response.data;
  }
);

const fetchArchiveServicesStudentSummarisedData = createAsyncThunk(
  "archive-services/fetchArchiveServicesStudentSummarisedData",
  async (filterObj) => {
    ////console.log('filterObj', filterObj)
    const response = await externalUtilityv1.post(`kpi/indicators-two/public`,filterObj);
    ////console.log('fetchArchiveServicesStudentSummarisedData', response)
    return response.data;
  }
);

const fetchArchiveServicesStudentGPIStatsData = createAsyncThunk(
  "archive-services/fetchArchiveServicesStudentGPIStatsData",
  async (filterObj) => {
    ////console.log('filterObj', filterObj)
    const response = await externalUtilityv1.post(`kpi/indicators-three/public`,{...filterObj, itemGroupId: 9});
    ////console.log('fetchArchiveServicesStudentGPIStatsData', response)
    return response.data;
  }
);

const fetchArchiveServicesGraphSchoolData = createAsyncThunk(
  "archive-services/fetchArchiveServicesGraphSchoolData",
  async (filterObj) => {
    const response = await externalAxios.post(`schools-basic-infra/public`,filterObj);
    return response.data;
  }
);

const fetchArchiveServicesPieGraphSchoolData = createAsyncThunk(
  "archive-services/fetchArchiveServicesPieGraphSchoolData",
  async (filterObj) => {
  
    const response = await externalAxios.post(`schools-basic-infra/public`,filterObj);
    return response.data;
  }
);


const fetchArchiveServicesTeacherDataSocialCatGender=createAsyncThunk(
  "archive-services/fetchArchiveServicesSchoolDataSocialActGender",
  async(filterObj)=>{
    const response=await externalAxios.post(`teachers/public`, filterObj);
    ////console.log('response.data', response.data)
    return response.data;
  }
)

const fetchArchiveServicesPtR=createAsyncThunk(
  "archive-services/fetchArchiveServicesTeacherPtr",
  async(filterObj)=>{
    localStorage.setItem("report2007", JSON.stringify(filterObj));
    const response=await externalAxios.post(`ptr/public `, filterObj);
    return response.data;
  }
)


//api to fetch ptr on the basis of years Category wise --->5 year data
const fetchArchiveServicesPtRYears = createAsyncThunk(
  "archive-services/fetchArchiveServicesPtRYears",

  async ({ dType, dCode,valueType,managementCode }) => {
    const response = await externalAxios.post(`ptr/public`,{
      regionType:dType,
      regionCode:dCode,
      valueType :valueType,

    });
    return response.data;
  }
);

//api to fetch ptr on the basis of years Management wise --->5 year data
const fetchArchiveServicesPtRYearsManagementWise = createAsyncThunk(
  "archive-services/fetchArchiveServicesPtRYearsManagementWise",

  async ({ dType, dCode,valueType,managementCode }) => {
    const response = await externalAxios.post(`ptr/public`,{
      regionType:dType,
      regionCode:dCode,
      valueType :valueType,
      managementCode:managementCode

    });
    return response.data;
  }
);


//api to fetch Indicators  on the basis of   ----->Dropout Rate/Promotion Rate/Repetition /Transition Rate

const fetchArchiveServicesEnrolmentRelatedIndicators = createAsyncThunk(
  "archive-services/fetchArchiveServicesEnrolmentRelatedIndicators",

  async ({ dType, dCode, itemGroupId, itemId, yearId }) => {
    const response = await externalAxios.post(`indicators-one/public`, {
      yearId: yearId,
      regionType: dType,
      regionCode: dCode,
      itemGroupId: itemGroupId,
      itemId: itemId,
    });
    return response.data;
  }
);



const updateMergeDataToActualData = createAsyncThunk(
  "archive-services/updateMergeDataToActualData",
  async (merged_data) => {
    return merged_data;
  }
);

export  {fetchArchiveServicesSchoolData,fetchArchiveServicesProfileSchoolData,
        fetchArchiveServicesClassesTaughtData, fetchArchiveServicesStudentSummarisedData,
        fetchArchiveServicesStudentGPIStatsData, fetchArchiveServicesStudentData,fetchArchiveServicesCWSNEnrolmentData,
        fetchArchiveServicesTeacherData,updateMergeDataToActualData, 
        fetchArchiveServicesGraphSchoolData,fetchArchiveServicesPieGraphSchoolData,
        fetchArchiveServicesTeacherDataSocialCatGender,fetchArchiveServicesTeacherTrainingData,
        fetchArchiveServicesPtR,fetchArchiveServicesPtRYears,fetchArchiveServicesPtRYearsManagementWise, 
        fetchArchiveServicesTeacherDisabilityData, fetchArchiveServicesEnrolmentRelatedIndicators
};